<script setup lang="ts">

import ActivitySelector from './components/ActivitySelector.vue'
import Explainer from './components/Explainer.vue';
import MarketGrowth from './components/MarketGrowth.vue'
import MontecarloRetirement from './components/MontecarloRetirement.vue'
import { RetirementConfig } from './fin/retirement_config.ts'
import SingleRetirement from './components/SingleRetirement.vue'
import { placeClickHandlersOnElementsWithTitleAttributes } from './components/title_popup.ts';
import { onMounted, ref } from 'vue';

interface calculatesWithConfig {
  calculate(config: RetirementConfig): void;
};

const singleRetirementRef = ref<calculatesWithConfig | null>(null);
const montecarloRetirementRef = ref<InstanceType<typeof MontecarloRetirement>|null>(null);

function redrawActivity(activity: string): void {
  if (activity == 'SingleRetirement') {
    // I am not sure there's any current benefit to redrawing => no-op.
  } else if (activity == 'MontecarloRetirement') {
    if (montecarloRetirementRef.value) {
      montecarloRetirementRef.value.redraw();
    }
  }
}

onMounted(() => {
  placeClickHandlersOnElementsWithTitleAttributes(document);
});

</script>

<template>
  <Explainer/>

  <!-- TODO - restore SingleRetirement as default -->
  <ActivitySelector
   activitySelected="SingleRetirement"
   @selectionChanged="(activity) => {console.log('App got activity selection change: ' + activity); redrawActivity(activity);}"
  >
    <SingleRetirement
      ref="singleRetirementRef"
      @configChanged="(cfg) => {console.log('App got config change from SingleRetirement'); montecarloRetirementRef?.calculate(cfg);}"
      />
    <MontecarloRetirement
      ref="montecarloRetirementRef"
      @configChanged="(cfg) => {console.log('App got config change from MontecarloRetirement'); singleRetirementRef?.calculate(cfg);}"
      />
    <MarketGrowth/>
  </ActivitySelector>
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
